<template>
    <div>

        <kgr-loading v-if="loading" />
        <kgr-form-scaffold
            v-else
            :pending="pending"
            :with-back-button="false"
            :save-button-disabled="editKindergartenConfigs.length === 0"
            @primaryBtnClicked="save()"
        >
            <table
                vue:is="kgr-table"
                class="kgr-table--block"
            >
                <thead>
                    <tr class="kgr-table__row">
                        <th vue:is="kgr-th">
                            {{ $t('Einrichtung') }}
                        </th>
                        <th vue:is="kgr-th">
                            {{ $t('Adresse') }}
                        </th>
                        <th vue:is="kgr-th">
                            {{ $t('ISBJ-Einrichtungsnummer (8-stellig)') }}
                        </th>
                        <th vue:is="kgr-th">
                            {{ $t('Kosten') }}
                        </th>
                        <th
                            vue:is="kgr-th"
                            class="kgr-table__cell--actions"
                        >
                            {{ $t('options') }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="kindergartenConfig in kindergartenConfigs"
                        class="kgr-table__row"
                    >
                        <td class="kgr-table__cell">
                            <a
                                :href="loginUrl(kindergartenConfig.kindergarten.id)"
                                class="kgr-link kgr-link--unobtrusive"
                            >{{ kindergartenConfig.kindergarten.name }}</a>
                        </td>

                        <td class="kgr-table__cell">
                            {{ kindergartenConfig.kindergarten.street }}, {{ kindergartenConfig.kindergarten.zipcode }} {{ kindergartenConfig.kindergarten.city }}
                        </td>

                        <td class="kgr-table__cell">
                            <div v-if="editKindergartenConfigs.indexOf(kindergartenConfig) !== -1">
                                <kgr-text-input
                                    v-model="editKindergartenConfigs[editKindergartenConfigs.indexOf(kindergartenConfig)].isbjNumber"
                                    inline
                                    :error="error.messageForField('configs[' + editKindergartenConfigs.indexOf(kindergartenConfig) + '][isbjNumber]')"
                                />
                            </div>
                            <template v-else>
                                {{ kindergartenConfig.isbjNumber }}
                            </template>
                        </td>

                        <td class="kgr-table__cell">
                            <template v-if="editKindergartenConfigs.indexOf(kindergartenConfig) !== -1">
                                <kgr-multi-select
                                    v-model="kindergartenConfig.costs"
                                    :options="getCostOptions(kindergartenConfig)"
                                />
                            </template>
                            <template v-else>
                                {{ kindergartenConfig.costs.map(cost => cost.label).join(', ') }}
                            </template>
                        </td>

                        <td class="kgr-table__cell kgr-table__cell--actions">
                            <kgr-icon-edit
                                :size="15"
                                :disabled="editKindergartenConfigs.indexOf(kindergartenConfig) !== -1"
                                class="kgr-table__action kgr-clickable"
                                :title="$t('Einstellungen bearbeiten')"
                                @click="edit(kindergartenConfig)"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </kgr-form-scaffold>
    </div>
</template>

<script>
import Error from '../../../js/model/Error';
import FormScaffold from '../../common/form/FormScaffold';
import IconEdit from '../../common/icon/IconEdit';
import IsbjKindergartenConfigsRepository from '../../../js/repository/IsbjKindergartenConfigsRepository';
import Loading from '../../common/Loading';
import MultiSelect from '../../common/form/select/MultiSelect';
import TextInput from '../../common/form/input/TextInput';

export default {
    components: {
        'kgr-loading': Loading,
        'kgr-text-input': TextInput,
        'kgr-icon-edit': IconEdit,
        'kgr-form-scaffold': FormScaffold,
        'kgr-multi-select': MultiSelect,
    },
    props: {
        federation: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            loading: true,
            pending: false,
            kindergartenConfigs: [],
            editKindergartenConfigs: [],
            error: new Error(),
        }
    },
    created() {
        this.load();
    },
    methods: {
        load() {
            IsbjKindergartenConfigsRepository
                .find(this.federation)
                .then(data => {
                    this.kindergartenConfigs = data;
                    this.loading = false;
                });
        },
        edit(kindergartenConfig) {
            if (this.editKindergartenConfigs.indexOf(kindergartenConfig) !== -1) {
                return;
            }

            this.editKindergartenConfigs.push(kindergartenConfig);
        },
        save() {
            if (this.editKindergartenConfigs.length > 0) {
                this.pending = true;
                IsbjKindergartenConfigsRepository
                    .update(this.federation, this.editKindergartenConfigs)
                    .then(() => {
                        this.editKindergartenConfigs = [];
                        this.error = new Error();
                        this.$notify.success('saveChanges.success');
                    })
                    .catch(error => {
                        this.$notify.error('saveChanges.error');
                        this.error = error;
                        this.$forceUpdate();
                    })
                    .finally(() => this.pending = false);
            }
        },
        loginUrl(id) {
            return `/federation/login/kindergarten/${id}`;
        },
        getCostOptions(kindergartenConfig) {
            return kindergartenConfig.allCosts.filter(cost => kindergartenConfig.costs.map(cost => cost.id).indexOf(cost.id) === -1);
        }
    },
}
</script>
